import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { TypeProjet } from '../../../../shared/constants/type-projet.enum';
import { StatusPreautorisation } from '../../../../shared/modeles/variables';
import { InstitutionEnum } from '../../constants/institution.enum';

const BASE_PATH = 'preautorisation-simplifiee';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  constructor(private readonly router: Router, private readonly ngZone: NgZone) {}

  async navigatePageFormulaire() {
    await this.ngZone.run(async () => {
      await this.router.navigateByUrl(`${BASE_PATH}/formulaire`, { skipLocationChange: true });
    });
  }

  async navigatePageAccueil() {
    await this.ngZone.run(async () => {
      await this.router.navigateByUrl(BASE_PATH);
    });
  }

  async navigatePageResultat() {
    await this.ngZone.run(async () => {
      await this.router.navigateByUrl(`${BASE_PATH}/resultat`);
    });
  }

  async navigatePageDetails() {
    await this.ngZone.run(async () => {
      await this.router.navigateByUrl(`${BASE_PATH}/details`);
    });
  }

  async navigatePageNonEligible() {
    await this.ngZone.run(async () => {
      await this.router.navigateByUrl(`${BASE_PATH}/non-eligible`, { skipLocationChange: true });
    });
  }

  async navigatePageFonctionInactiveTaux() {
    await this.ngZone.run(async () => {
      await this.router.navigateByUrl(`${BASE_PATH}/fonction-inactive-taux`);
    });
  }

  async navigatePageInvitation() {
    await this.ngZone.run(async () => {
      await this.router.navigateByUrl(`${BASE_PATH}/invitation`, { skipLocationChange: true });
    });
  }

  async navigatePagePreautEnCours(typeProjet: TypeProjet, statut: StatusPreautorisation, institution: InstitutionEnum) {
    await this.ngZone.run(async () => {
      await this.router.navigateByUrl(`${BASE_PATH}/en-cours`, {
        state: { typeProjet, statut, institution }
      });
    });
  }

  async navigatePagePanne() {
    await this.ngZone.run(async () => {
      await this.router.navigateByUrl(`${BASE_PATH}/panne`, { skipLocationChange: true });
    });
  }

  async navigateDashboard() {
    await this.ngZone.run(async () => {
      await this.router.navigateByUrl('');
    });
  }

  async navigatePageAnnuleParCoemprunteur() {
    await this.ngZone.run(async () => {
      await this.router.navigateByUrl(`${BASE_PATH}/demande-annulee`, { skipLocationChange: true });
    });
  }

  async navigateToProjet(typeProjet: TypeProjet, showDashboard: boolean) {
    window.location.href = `${showDashboard ? '' : BASE_PATH}?projet=${typeProjet}`;
  }
}
